// Utility function to map language codes to Azure AD B2C format
export const getAzureB2CLocale = (language: string): string => {
  switch (language) {
    case 'en':
      return 'en-US';
    case 'nl':
      return 'nl-NL';
    default:
      return 'nl-NL'; // Default to Dutch
  }
};
